export var PAYMENT_TYPES = {
  OTHER: 'OTHER',
  CB: 'CB',
  BA: 'BA',
  AVOIR: 'AVOIR',
  CKDO: 'CKDO',
  VIREMENT: 'VIREMENT',
  CHEQUE: 'CHEQUE',
  ECHANGE: 'ECHANGE',
  PAYPAL: 'PAYPAL',
  SOFORT: 'SOFORT',
  GIROPAY: 'GIROPAY',
  EPS: 'EPS',
  IDEAL: 'IDEAL',
  PAYPALEXPRESS: 'PAYPALEXPRESS',
  NXCB: 'NXCB',
  CETELEMPRESTO: 'CETELEMPRESTO',
  CETELEM: 'CETELEM',
  CETELEM4XCB: 'CETELEM4XCB',
  AURORE: 'AURORE',
  SEQURA: 'SEQURA'
};
export var PAYMENT_LIST = {
  CB: 'cb',
  PAYPAL: 'paypal',
  VIREMENT: 'vir',
  CETELEM_4XCB: 'cetelem',
  CARTE_CADEAU: 'ccadeau',
  BON_ACHAT: 'bonachat',
  AVOIR: 'avoir',
  ALMA: 'alma'
};